module.exports = __webpack_public_path__ + "static/media/eraser.063de23f.svg";